declare const angular;
const template = require('./transfer_show.html.slim')
import { assign } from 'lodash'

export class TransferShow {
  static $inject = [
    '$scope',
    '$rootScope',
    'moment',
    '$window',
    '$location',
    '$routeParams',
    'Transfer',
    'InvestmentAccountTransfersIn',
    'TransferStatus',
    'Comment',
    'TransactionsDirect',
    '$filter'
  ]

  public transfer
  public daysOutstanding
  public daysToComplete
  public comments
  public newComment
  public changingStatus: boolean
  public newCommentError
  public commentError
  public matchingTransactions
  public matches

  public transferForm
  public notification: boolean
  public notificationBody = {}

  public isEditingStaffDetails: boolean
  public staffDetailsForm

  public currentExpectedMethod
  public currentExpectedAmount
  public currentRelinquishingInstitution

  public newExpectedMethod
  public newExpectedAmount
  public newRelinquishingInstitution

  public transferMetricsError: string

  public undoLoading

  private transferResource
  private commentResource
  private transactionsResource
  private transferId: number
  private addCommentWait: boolean
  private saveCommentWait: boolean
  private location

  constructor(
    public $scope,
    public $rootScope,
    public moment,
    public $window,
    private $location,
    private $routeParams,
    private Transfer,
    private InvestmentAccountTransfersIn,
    private TransferStatus,
    private Comment,
    private TransactionsDirect,
    private $filter
  ) {
    this.transferResource = Transfer
    this.commentResource = Comment
    this.transactionsResource = TransactionsDirect
    this.transferId = $routeParams.id
    this.location = $location

    this.transferResource.get({
      id: this.transferId,
      userDate: this.moment().format(),
    }, (transfer) => {
      this.transfer = transfer
      this.transfer.bankInfo = JSON.parse(this.transfer.bankInfo);

      if (this.transfer.expectedMethod !== undefined) {
        this.currentExpectedMethod = this.transfer.expectedMethod;
      } else {
        this.currentExpectedMethod = this.transfer.amountValue !== null ? 'partial' : 'entire';
      }

      if (this.transfer.expectedAmount !== undefined && this.transfer.expectedAmount !== null) {
        this.currentExpectedAmount = this.transfer.expectedAmount;
      } else {
        this.currentExpectedAmount = this.transfer.amountValue;
      }
      this.currentRelinquishingInstitution = this.transfer.relinquishingInstitution;

      if (transfer.status === 'edit_requested') { this.createTransferNotification(transfer) }
      if (transfer.sentAt) {
        var sentAt = this.moment(transfer.sentAt)
        this.daysOutstanding = this.moment().diff(sentAt, 'days')
        if (transfer.completedAt) {
          this.daysToComplete = this.moment(transfer.completedAt).diff(sentAt, 'days') + 1
        }
      }
      this.setInitialStaffDetailsInputValues()
    })

    this.getMatchedTransactions()
    this.loadComments()

    $rootScope.$on('$routeUpdate', (() => {
      this.getMatchedTransactions()
    }))
  }

  public setInitialStaffDetailsInputValues(): void {
    this.newExpectedMethod = this.currentExpectedMethod;
    this.newExpectedAmount = this.currentExpectedAmount;
    this.newRelinquishingInstitution = this.currentRelinquishingInstitution;
  }

  public complete(): void {
    this.changeStatus('completed')
  }

  public process(): void {
    this.changeStatus('in_progress')
  }

  public active(): void {
    this.changeStatus('active')
  }

  public cancelled(): void {
    this.changeStatus('cancelled')
  }

  public cancelTransfer(): void {
    this.$scope.transferAdminCancelDialog.show()
  }

  public decideTransferResource({ category }) {
    if (category === 'transfer') return this.InvestmentAccountTransfersIn;
    return this.Transfer;
  }

  public cancelActive(): void {
    this.decideTransferResource(this.transfer).delete({
      id: this.transferId
    }, () => {
      this.$window.location.assign('/app/transfers')
    })
  }

  /**
   * Match the transfer to a transaction specified by id
   *
   * @param {number} transactionId
   */
  public matchTransaction(transactionId: number): void {
    this.transactionsResource.update({
      id: transactionId,
      matchingTransferId: this.transferId,
    }, (_) => {
      this.getMatchedTransactions()
      this.loadTransfer()
    })
  }

  public unmatchTransaction(transactionId: number): void {
    this.transactionsResource.update({
      id: transactionId,
      unmatch: true,
    }, (transaction) => {
      this.getMatchedTransactions()
      this.loadTransfer()
    })
  }

  /**
   * Checks whether the matching transaction list should be shown
   *
   * @returns {boolean}
   */

  public showUndoTransfer(): boolean {
    if (this.transfer) {
      return (
        this.transfer.status === 'completed' ||
        this.transfer.status === 'cancelled' ||
        (this.transfer.status === 'active' &&
          this.transfer.previousProperties.status !== 7)
      )
    }
  }

  public showBackToTransfer(): boolean {
    if (this.transfer) {
      return (
        this.transfer.status === 'edit_requested' ||
        (this.transfer.status === 'cancel_requested' &&
          this.transfer.previousProperties.status !== 4)
      )
    }
  }

  public addComment(): void {
    if (!this.addCommentWait) {
      this.addCommentWait = true
      this.newCommentError = null
      this.transferResource.addComment({
        id: this.transferId,
        content: this.newComment,
      }).$promise.then((comment) => {
        this.newComment = null
        this.comments.push(comment)
      }).catch((e) => {
        this.newCommentError = 'Error: ' + e.status + ' ' + e.statusText
      }).finally(() => {
        this.addCommentWait = false
      })
    }
  }

  /**
   * Edit a comment
   * @param {Object} comment A comment object
   */
  public editComment(comment): void {
    for (var c of this.comments) {
      c.isEditing = false
    }
    comment.isEditing = true
  }

  /**
   * Save a comment that has been edited
   * @param {Object} comment A comment object
   */
  public saveComment(comment): void {
    if (!this.saveCommentWait) {
      this.saveCommentWait = true
      this.commentError = null
      this.commentResource.update(comment).$promise.then((updatedComment) => {
        assign(comment, updatedComment)
        comment.isEditing = false
      }).catch((e) => {
        this.commentError = 'Error: ' + e.status + ' ' + e.statusText
      }).finally(() => {
        this.saveCommentWait = false
      })
    }
  }

  public deleteComment(comment): void {
    this.commentResource.delete(comment, () => {
      this.loadComments()
    })
  }

  frequencies(value) {
    let frequencies = [
      { name: 'Weekly', frequency: 52 },
      { name: 'Every two weeks', frequency: 26 },
      { name: 'Twice a month', frequency: 24 },
      { name: 'Monthly', frequency: 12 },
      { name: 'Every three months', frequency: 4},
    ]
    return frequencies.filter((f) => f.frequency === value)
  }

  public createTransferNotification(transfer) {
    this.notification = true;
    let preEdit = transfer.previousProperties.preEdit;

    if (parseInt(preEdit.amountValue) !== transfer.amountValue) {
      this.notificationBody['amountValue'] = `Amount was edited from
      ${this.$filter('currency')(preEdit.amountValue)}
      to ${this.$filter('currency')(transfer.amountValue)}`;
    }
    if (preEdit.frequency !== transfer.frequency) {
      this.notificationBody['frequency'] = `Frequency was edited from
      ${this.frequencies(preEdit.frequency)[0].name} to
      ${this.frequencies(transfer.frequency)[0].name}`;
    }
    if (preEdit.transferAt !== transfer.transferAt) {
      this.notificationBody['transferAt'] = `Transfer date was edited from
      ${this.$filter('date')(preEdit.transferAt)} to ${this.$filter('date')(transfer.transferAt)}`;
    }
    if (preEdit.accountNumber !== transfer.investmentAccount.accountNumber) {
      this.notificationBody['accountNumber'] = `Target account was edited from
      ${preEdit.accountNumber} to ${transfer.investmentAccount.accountNumber}`;
    }

    if (Object.keys(this.notificationBody).length === 0) {
      this.notification = false;
      this.notificationBody['noEdits'] = "No edits were made, or they were reset to previous values"
    }
  }

  public undoDialog() {
    this.$scope.undoStatusDialog.show()
  }

  public undo() {
    // FIX?: This does not actually have full functionality
    this.undoLoading = true;
    this.TransferStatus.delete({
      id: this.transferId,
      status: this.transfer.status,
    }, transfer => {
      this.undoLoading = false;
      this.loadComments()
    }, error => {
      this.undoLoading = false;
      this.$scope.errorRevertingDialog.show()
    })
  }

  public createdAndSubmmitedSameDate() {
    return this.moment(this.transfer.createdAt).isSame(this.transfer.submittedAt, 'd')
  }

  public isWithdrawal() {
    return this.transfer && (this.transfer.category === 'withdrawal' || this.transfer.category === 'withdrawal_all')
  }

  public sourceOfFundsString(value) {
    switch(value) {
      case 'employment':
        return 'Employment Income';
      case 'investment':
        return 'Investment Income';
      case 'savings':
        return 'Savings';
      case 'inheritance':
        return 'Inheritance';
      case 'legal_settlement':
        return 'Payment for Legal Settlement';
      case 'sale_of_asset':
        return 'Sale of an Asset';
      case 'gift':
        return 'Gift';
      case 'other':
        return 'Other';
      default:
        return null;
    }
  }

  public toggleEditStaffDetails(): void {
    this.transferMetricsError = null;
    this.isEditingStaffDetails = !this.isEditingStaffDetails;
  }

  public submitStaffDetailsForm(): void {
    const data = {
      id: this.transferId,
      expected_method: this.newExpectedMethod,
      expected_amount: this.newExpectedAmount,
      relinquishing_institution: this.newRelinquishingInstitution,
    }

    this.transferResource
      .updateStaffDetails(data)
      .$promise.then((response) => {
        if (response && response.message) {
          this.currentExpectedMethod = data.expected_method;
          this.currentExpectedAmount = data.expected_amount;
          this.currentRelinquishingInstitution = data.relinquishing_institution;
        }
        this.toggleEditStaffDetails();
      }).catch((error) => {
        this.transferMetricsError = 'Error: ' + error.status + ' ' + error.statusText;
      }).finally(() => {
        if (this.staffDetailsForm) { this.staffDetailsForm.$setPristine() }
      });
  }

  private loadComments(): void {
    this.comments = this.transferResource.getComments({ id: this.transferId })
  }

  private getMatchedTransactions(): void {
    this.transferResource.transactionMatches({
      id: this.transferId
    }, (transactions) => {
      this.matches = transactions
      // set up count for footer component
      this.matches.totalCount = this.matches.length
    })
  }

  private loadTransfer(): void {
    this.transferResource.get({
      id: this.transferId,
      userDate: this.moment().format(),
    }, (transfer) => {
      this.transfer = transfer
    })
  }

  private changeStatus(state): void {
    this.changingStatus = true
    this.TransferStatus.update({
      id: this.transferId,
      status: state,
    }, () => {
      this.transfer.status = state;
      this.changingStatus = false
      this.loadComments()
      if (this.transferForm) { this.transferForm.$setPristine() }
    })
  }
}

angular.module('wbComponents').directive('transferShow', function () {
  return {
    restrict: 'E',
    replace: true,
    controller: TransferShow,
    controllerAs: 'ctrl',
    templateUrl: template,
    bindToController: true,
  }
})
